import { duplicateBackup } from "../../../../../api/backup/backup";

export const DuplicateOrderBackup = async (backup) => {
  try {
    const response = await duplicateBackup(backup);
    return response.data;
  } catch (error) {
    return error.response?.data;
  }
};
